import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useGettext } from '@jshmrtn/vue3-gettext';
import auth from '@/core/Auth';
import { Loader } from '@/core/Loader';
import { ErrorBag, handleFormError } from '@/core/common';
import LoginLayout from '@/modules/login/components/LoginLayout.vue';
import AppFormGroup from '@/core/components/form/AppFormGroup.vue';
import AppInput from '@/core/components/form/AppInput.vue';
import AppButton from '@/core/components/form/AppButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginPage',
  setup(__props) {

const { $gettext } = useGettext();
const router = useRouter();
const email = ref<string>('');
const password = ref<string>('');
const errors = ref<ErrorBag>({});

const login = async () => {
	try {
		const user = await auth.authenticate(email.value, password.value);

		if (user.requires_verification) {
			router.push({
				name: 'login.mfa',
			});
		} else {
			router.push(auth.getLoginRedirect());
		}
	} catch (e) {
		handleFormError(e as Error, errors);
		Loader.hide();
	}
};

return (_ctx: any,_cache: any) => {
  const _component_translate = _resolveComponent("translate")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createBlock(LoginLayout, {
    "page-title": _unref($gettext)('Logga in')
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("h2", null, [...(_cache[2] || (_cache[2] = [
        _createTextVNode("Logga in", -1)
      ]))])), [
        [_directive_translate]
      ]),
      _createElementVNode("form", {
        class: "login-form",
        onSubmit: _withModifiers(login, ["prevent"])
      }, [
        _createVNode(AppFormGroup, {
          id: "login_email",
          label: _unref($gettext)('E-postadress')
        }, {
          default: _withCtx(() => [
            _createVNode(AppInput, {
              id: "login_email",
              modelValue: email.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
              required: "",
              autofocus: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(AppFormGroup, {
          id: "login_password",
          label: _unref($gettext)('Lösenord'),
          required: ""
        }, {
          default: _withCtx(() => [
            _createVNode(AppInput, {
              type: "password",
              id: "login_password",
              modelValue: password.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
              required: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(AppButton, {
          class: "t-primary button-block",
          type: "submit"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_translate, null, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("Logga in", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        })
      ], 32),
      _createElementVNode("p", null, [
        _withDirectives((_openBlock(), _createBlock(_component_RouterLink, { to: {name: 'login.forgot'} }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createTextVNode(" Glömt lösenordet? ", -1)
          ]))]),
          _: 1
        })), [
          [_directive_translate]
        ])
      ])
    ]),
    _: 1
  }, 8, ["page-title"]))
}
}

})